import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";

export default function ConfirmDialog({ title, message, confirmLabel = "Conferma", danger = true, onConfirm, onClose }) {
  const [loading, setLoading] = useState(false);
  const run = async () => {
    setLoading(true);
    try { await onConfirm(); } finally { setLoading(false); }
  };
  return (
    <div className="fixed inset-0 z-[70] bg-[#1a1a1a]/50 flex items-center justify-center p-4" data-testid="confirm-dialog">
      <div className={`bg-white rounded-lg shadow-lg w-full max-w-sm p-4 border-t-2 ${danger ? "border-[#9b2c2c]" : "border-[#C9A84C]"}`}>
        <div className="flex items-start gap-3 mb-5">
          <AlertTriangle className={`w-5 h-5 shrink-0 mt-0.5 ${danger ? "text-[#9b2c2c]" : "text-[#C9A84C]"}`} />
          <div>
            <h3 className="font-serif text-xl text-[#1A2B4A]">{title}</h3>
            <p className="text-sm text-[#4a5568] mt-1 whitespace-pre-line">{message}</p>
          </div>
        </div>
        <div className="flex justify-end gap-3">
          <button data-testid="confirm-cancel" onClick={onClose} disabled={loading}
            className="px-4 py-2 text-sm border border-[#1A2B4A] rounded-sm hover:bg-[#f9f8f5]">Annulla</button>
          <button data-testid="confirm-ok" onClick={run} disabled={loading}
            className={`inline-flex items-center gap-2 px-4 py-2 text-sm text-white rounded-sm disabled:opacity-50 ${danger ? "bg-[#9b2c2c] hover:bg-[#7a2222]" : "bg-[#1A2B4A] hover:bg-[#C9A84C]"}`}>
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
